/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './TemplateInstantiationService';
import * as Queries from './TemplateInstantiationService.dfc.new';
import type { AdditionalContextArgs } from './TemplateInstantiationService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseInstantiateTemplateMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.InstantiateTemplateResponseType>,
    References.InstantiateTemplateRequestType,
    T extends true
      ? Record<
          'instantiateTemplate',
          References.InstantiateTemplateResponseType
        >
      : References.InstantiateTemplateResponseType
  >;

export function useInstantiateTemplateMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.InstantiateTemplateResponseType>,
    References.InstantiateTemplateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseInstantiateTemplateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.INSTANTIATE_TEMPLATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            instantiateTemplate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseInstantiateTemplateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseInstantiateTemplateMutationReturn<T>;
}

type UseGetInstantiationStatusQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetInstantiationStatusResponseType>,
    References.GetInstantiationStatusRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getInstantiationStatus',
            References.GetInstantiationStatusResponseType
          >
        : References.GetInstantiationStatusResponseType)
    | undefined;
};

export function useGetInstantiationStatusQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetInstantiationStatusResponseType>,
    References.GetInstantiationStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstantiationStatusQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_INSTANTIATION_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstantiationStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstantiationStatusQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstantiationStatusQueryReturn<T>;
}

type UseGetInstantiationStatusLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetInstantiationStatusResponseType>,
    References.GetInstantiationStatusRequestType,
    T extends true
      ? Record<
          'getInstantiationStatus',
          References.GetInstantiationStatusResponseType
        >
      : References.GetInstantiationStatusResponseType
  >;

export function useGetInstantiationStatusLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetInstantiationStatusResponseType>,
    References.GetInstantiationStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstantiationStatusLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_INSTANTIATION_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstantiationStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetInstantiationStatusLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetInstantiationStatusLazyQueryReturn<T>;
}

type UseGetInstantiationStatusSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetInstantiationStatusResponseType>,
    References.GetInstantiationStatusRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getInstantiationStatus',
        References.GetInstantiationStatusResponseType
      >
    : References.GetInstantiationStatusResponseType;
};

export function useGetInstantiationStatusSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetInstantiationStatusResponseType>,
    References.GetInstantiationStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstantiationStatusSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_INSTANTIATION_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getInstantiationStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstantiationStatusSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstantiationStatusSuspenseQueryReturn<T>;
}

type UseListInstantiationRequestsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListInstantiationRequestsResponseType>,
    References.ListInstantiationRequestsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listInstantiationRequests',
            References.ListInstantiationRequestsResponseType
          >
        : References.ListInstantiationRequestsResponseType)
    | undefined;
};

export function useListInstantiationRequestsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListInstantiationRequestsResponseType>,
    References.ListInstantiationRequestsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListInstantiationRequestsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_INSTANTIATION_REQUESTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listInstantiationRequests: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListInstantiationRequestsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListInstantiationRequestsQueryReturn<T>;
}

type UseListInstantiationRequestsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListInstantiationRequestsResponseType>,
    References.ListInstantiationRequestsRequestType,
    T extends true
      ? Record<
          'listInstantiationRequests',
          References.ListInstantiationRequestsResponseType
        >
      : References.ListInstantiationRequestsResponseType
  >;

export function useListInstantiationRequestsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListInstantiationRequestsResponseType>,
    References.ListInstantiationRequestsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListInstantiationRequestsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_INSTANTIATION_REQUESTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listInstantiationRequests: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListInstantiationRequestsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListInstantiationRequestsLazyQueryReturn<T>;
}

type UseListInstantiationRequestsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListInstantiationRequestsResponseType>,
    References.ListInstantiationRequestsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'listInstantiationRequests',
        References.ListInstantiationRequestsResponseType
      >
    : References.ListInstantiationRequestsResponseType;
};

export function useListInstantiationRequestsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListInstantiationRequestsResponseType>,
    References.ListInstantiationRequestsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListInstantiationRequestsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_INSTANTIATION_REQUESTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listInstantiationRequests: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListInstantiationRequestsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListInstantiationRequestsSuspenseQueryReturn<T>;
}

type UseListWorkflowsForTemplateQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListWorkflowsForTemplateResponseType>,
    References.ListWorkflowsForTemplateRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listWorkflowsForTemplate',
            References.ListWorkflowsForTemplateResponseType
          >
        : References.ListWorkflowsForTemplateResponseType)
    | undefined;
};

export function useListWorkflowsForTemplateQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListWorkflowsForTemplateResponseType>,
    References.ListWorkflowsForTemplateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListWorkflowsForTemplateQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_WORKFLOWS_FOR_TEMPLATE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listWorkflowsForTemplate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListWorkflowsForTemplateQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListWorkflowsForTemplateQueryReturn<T>;
}

type UseListWorkflowsForTemplateLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListWorkflowsForTemplateResponseType>,
    References.ListWorkflowsForTemplateRequestType,
    T extends true
      ? Record<
          'listWorkflowsForTemplate',
          References.ListWorkflowsForTemplateResponseType
        >
      : References.ListWorkflowsForTemplateResponseType
  >;

export function useListWorkflowsForTemplateLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListWorkflowsForTemplateResponseType>,
    References.ListWorkflowsForTemplateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListWorkflowsForTemplateLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_WORKFLOWS_FOR_TEMPLATE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listWorkflowsForTemplate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListWorkflowsForTemplateLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListWorkflowsForTemplateLazyQueryReturn<T>;
}

type UseListWorkflowsForTemplateSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListWorkflowsForTemplateResponseType>,
    References.ListWorkflowsForTemplateRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'listWorkflowsForTemplate',
        References.ListWorkflowsForTemplateResponseType
      >
    : References.ListWorkflowsForTemplateResponseType;
};

export function useListWorkflowsForTemplateSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListWorkflowsForTemplateResponseType>,
    References.ListWorkflowsForTemplateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListWorkflowsForTemplateSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_WORKFLOWS_FOR_TEMPLATE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listWorkflowsForTemplate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListWorkflowsForTemplateSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListWorkflowsForTemplateSuspenseQueryReturn<T>;
}
